import { BrowserRouter, Route, Routes } from "react-router-dom"
import Dashboard from "./pages/Dashboard"
import "./styles/main.scss"
import TicketsList from "./pages/TicketsList"
import AgentsList from "./pages/AgentsList"
import UsersList from "./pages/UsersList"
import TicketDetail from "./pages/TicketDetail"
import Profile from "./pages/Profile"
import UserForm from "./pages/user/UserForm"
import Login from "./pages/auth/Login"
import ForgotPassword from "./pages/auth/ForgotPassword"
import ChangePassword from "./pages/ChangePassword"
import AgentTicket from "./pages/AgentTicket"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import Example from "./pages/TicketList2"
import { createContext, useState } from "react"
import { jwtDecode as decode } from "jwt-decode"
import { useEffect } from "react"
import NotFoundTitle from "./pages/404page"
import AgentsTicketsAssigned from "./pages/AgentsTicketsAssigned"
import ClosedTicketsAgents from "./pages/ClosedTicketsAgents"

export const AppContext = createContext();

function App() {
	const [isvalid, setIsvalid] = useState(false)
	const [triggerRefresh, setTriggerRefresh] = useState(0)

	const Token = localStorage.getItem("Token")

	const state = { triggerRefresh }
	const actions = { setTriggerRefresh }

	useEffect(() => {
		if (Token) {
			let decoded

			try {
				decoded = decode(Token)
			} catch (error) {
				console.error(error)
				localStorage.removeItem("Token")
				return
			}

			// Check if token is expired
			const timestamp = Math.floor(Date.now() / 1000)

			if (decoded.exp >= timestamp) {
				setIsvalid(true)
			}
			// Token is expired
			else {
				localStorage.removeItem("Token")
			}
		}
		else {
			setIsvalid(false)
		}
	}, [Token, triggerRefresh])

	if (isvalid) {
		return (
		<>
			<ToastContainer />
			<AppContext.Provider value={{ state, actions }}>
			<Routes>
				<Route path="/" element={<Dashboard />} />
				<Route path="/dashboard" element={<Dashboard />} />
				<Route path="/tickets" element={<Example />} />
				<Route path="/mytickets" element={<AgentTicket />} />
				<Route path="/agents" element={<AgentsList />} />
				<Route path="/users" element={<UsersList />} />
				<Route path="/ticketdetail/:ticket_id" element={<TicketDetail />} />
				<Route path="/profile" element={<Profile />} />
				<Route path="/changepassword" element={<ChangePassword />} />
				<Route path="/userform" element={<UserForm />} />
				<Route path="/ticketsassigned/:agent_id" element={<AgentsTicketsAssigned />} />
				<Route path="/ticketsclosed/:agent_id" element={<ClosedTicketsAgents/>} />
				
				<Route path="*" element={<NotFoundTitle />} />
			</Routes>
			</AppContext.Provider>
		</>
		)
	}

	return (
		<><ToastContainer />
		<AppContext.Provider value={{ state, actions }}>
		<Routes>
			<Route path="/" element={<Login />} />
			<Route path="*" element={<Login />} />
			<Route path="/forgotpassword" element={<ForgotPassword />} />
		</Routes>
		</AppContext.Provider>
		</>
	)
}

export default App
